import { render, staticRenderFns } from "./TabIntroduction.vue?vue&type=template&id=05b4bcee&"
import script from "./TabIntroduction.vue?vue&type=script&lang=js&"
export * from "./TabIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports